import React, {  useEffect, useRef, useState} from "react";
import { Card, Button, message, Popover } from "antd";
import {
  DownOutlined,
  EnvironmentOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { CustomTable } from "@/hocComponents";
import http from "@/utils/http";
import api from "@/utils/api";
import dayjs from "dayjs";
import commonFn from "@/utils/commonFn";
export default function PropertyBreakdown({
  period,
  ownerId,
  ownerRecord,
  visible,
  onClose,
}) {
  const [propertyData, setPropertyData] = useState([]);
  const [propertyLoading, setPropertyLoading] = useState(false);
  const [propertyYear, setPropertyYear] = useState({
    period_start_min: "",
    period_end_max: "",
  });

  const initTableHead = {
    prop: undefined,
  };

  const [propertyCounts, setPropertyCounts] = useState({
    total: 0,
    active: 0,
    inactive: 0,
    activeUnits: 0,
    inactiveUnits: 0,
    positiveCashFlow: 0,
    negativeCashFlow: 0,
    cashFlowAll: 0,
    vacancyAll: 0,
    evictionNum: 0,
    vacancyNum: 0,
  });

  const getPropertyValueClassName = (value) => {
    const valueLength = String(value ?? "").length;

    if (valueLength >= 17) {
      return "property-card-value property-card-value-dense";
    }

    if (valueLength >= 13) {
      return "property-card-value property-card-value-compact";
    }

    return "property-card-value";
  };

  const propertyColumns = [
    {
      title: "",  
      placeholder: "prop", 
      dataIndex: "prop",
      titleType: "Input",
      onChange: e => tableFilterFn(e, 'prop'),
      render: (text, record) => {
        const isInactive = record.propStatus === "Inactive";
        const card = record.propCard || {};

        const statusColor = card.status === "Active" ? "#0f9d58" : "#0958d9";
        const statusBg = card.status === "Active" ? "#e6f9f0" : "#e6f4ff";

        const content = (
          <div
            style={{
              padding: 16,
              width: 450,
              fontFamily: "Inter, sans-serif",
            }}
          >
            {/* Title row: Property + Units + Status */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 2 }}>
                  Prop - {card.property}
                </div>

                <div
                  style={{
                    fontSize: 13,
                    color: "#1677ff",
                    fontWeight: 500,
                    marginLeft: 10,
                  }}
                >
                  {card.units === null ||
                  card.units === undefined ||
                  card.units === ""
                    ? "-"
                    : `${card.units} Units`}
                </div>
              </div>

              {/* Status badge */}
              {card.status && (
                <span
                  style={{
                    padding: "3px 10px",
                    fontSize: 12,
                    fontWeight: 500,
                    borderRadius: 6,
                    color: statusColor,
                    background: statusBg,
                    whiteSpace: "nowrap",
                  }}
                >
                  {card.status}
                </span>
              )}
            </div>

            {/* Address */}
            <div
              style={{
                marginTop: 10,
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <BankOutlined style={{ color: "#1677ff" }} />
              <span style={{ fontSize: 13, color: "#555" }}>
                {card.propType || ""}
              </span>
            </div>
            <div
              style={{
                marginTop: 10,
                display: "flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              <EnvironmentOutlined style={{ color: "#1677ff" }} />
              <span style={{ fontSize: 13, color: "#555" }}>
                {card.street || ""} {card.city && `, ${card.city}`}{" "}
                {card.state && `, ${card.state}`} {card.zip && `, ${card.zip}`}
              </span>
            </div>
            <div
              style={{
                border: "1px solid #eee",
                borderRadius: 10,
                padding: 10,
                marginTop: 20,
              }}
            >
              <div style={{ display: "flex", marginBottom: 8 }}>
                <div style={{ width: 200, color: "#555" }}>
                  Supervisor Name.Group
                </div>
                <div style={{ fontWeight: 600 }}>
                  {card.superName}-{card.group}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 200, color: "#555" }}>Purchase Price</div>
                <div style={{ fontWeight: 600 }}>{card.purchasePriceStr}</div>
              </div>

              {card.units !== 1 && (
                <>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: 200, color: "#555" }}>
                      Purchase Price/ Units
                    </div>
                    <div style={{ fontWeight: 600 }}>
                      {card.unitPurchasePriceStr}
                    </div>
                  </div>
                </>
              )}
              <div style={{ display: "flex", marginBottom: 8 }}>
                <div style={{ width: 200, color: "#555" }}>Purchase Date</div>
                <div style={{ fontWeight: 600 }}>
                  {card.purchaseDate
                    ? dayjs(card.purchaseDate).format("MM/DD/YYYY")
                    : " "}
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: 200, color: "#555" }}>Monthly Rent</div>
                <div style={{ fontWeight: 600 }}>
                  {card.unitRentPriceSUMStr}
                </div>
              </div>

              {card.units !== 1 && (
                <>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: 200, color: "#555" }}>Rent/ Units</div>
                    <div style={{ fontWeight: 600 }}>
                      {card.unitRentPriceAVGStr}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        );
        return (
          <Popover content={content} placement="right">
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                cursor: "pointer",
                color: "#1677ff",
              }}
            >
              <span>{text}</span>

              {isInactive && (
                <span
                  style={{
                    padding: "2px 6px",
                    fontSize: 12,
                    borderRadius: 6,
                    color: "#0958d9",
                    background: "#e6f4ff",
                  }}
                >
                  Inactive
                </span>
              )}
            </span>
          </Popover>
        );
      },
    },
    {
      title: "Gross Rent",
      dataIndex: "gross_rent_fmt",
      sorter: true,
    },
    {
      title: "Vacancy",
      dataIndex: "vacancy_fmt",
      sorter: true,
    },
    {
      title: "Rent Collected",
      dataIndex: "rent_collected_fmt",
      sorter: true,
    },
    {
      title: "Other Collected",
      dataIndex: "other_collected_fmt",
    },
    {
      title: "Expense",
      dataIndex: "expense_fmt",
      sorter: true,
    },
    {
      title: "Debt",
      dataIndex: "debt_fmt",
      sorter: true,
    },
    {
      title: "Cash Flow",
      dataIndex: "cash_flow_fmt",
      sorter: true,
    },
    {
      title: "Vacancy / Eviction",
      dataIndex: "vacancy_count",
      render: (_, record) => {
        const vacancy = record.vacancy_count ?? 0;
        const eviction = record.eviction_count ?? 0;
        return `${vacancy} / ${eviction}`;
      },
    },
    {
      title: "Utility Exp.",
      dataIndex: "utilityExp_fmt",
    },
    {
      title: "OpX",
      dataIndex: "opex_fmt",
    },
    {
      title: "Insurance",
      dataIndex: "insurance_fmt",
    },
    {
      title: "Prop Tax",
      dataIndex: "propTax_fmt",
    },
    {
      title: "CapX",
      dataIndex: "capx_fmt",
    },
  ];
  const [tableHead, setTableHead] = useState(initTableHead);
  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }


 const handleTableChange = (pagination, filters, sorter) => {
  let sort;
  let sortType;

  if (sorter?.order) {
    sort = sorter.field;
    sortType = sorter.order === "ascend" ? "asc" : "desc";
  }

  getTableListFn({
    ...tableHead,
    sort,
    sortType,
  });
};

  // ================= 请求 =================
  const getTableListFn = async (extraParams = {}) => {
    if (!period) return;

    setPropertyLoading(true);
    setPropertyData([]);
    setPropertyCounts({
      total: 0,
      active: 0,
      inactive: 0,
      activeUnits: 0,
      inactiveUnits: 0,
      positiveCashFlow: 0,
      negativeCashFlow: 0,
      cashFlowAll: 0,
      vacancyAll: 0,
      evictionNum: 0,
      vacancyNum: 0,
    });
    try {
      const params = {
        period,
        ownerIds: ownerId === "__ALL__" ? "" : ownerId,
         ...tableHead,
         ...extraParams,
      };

      const res = await http.get(api.getPropTableList, { params });

      if (res?.code !== "1") {
        message.error(res?.msg);
        return;
      }

      const list = (res.data.rows || []).map((r) => ({
        ...r,
        key: r.prop_id,
      }));

      const active = list.filter((r) => r.propStatus === "Active");
      const inactive = list.filter((r) => r.propStatus === "Inactive");

      const activeUnits = active.reduce(
        (sum, r) => sum + (Number(r.propCard?.units) || 0),
        0,
      );
      const inactiveUnits = inactive.reduce(
        (sum, r) => sum + (Number(r.propCard?.units) || 0),
        0,
      );

      setPropertyData(list);
      setPropertyCounts({
        total: list.length,
        active: active.length,
        inactive: inactive.length,
        activeUnits,
        inactiveUnits,
        positiveCashFlow: res.data.positiveCashFlow || 0,
        negativeCashFlow: res.data.negativeCashFlow || 0,
        cashFlowAll: res.data.cashFlowAll || 0,
        vacancyAll: res.data.vacancyAll || 0,
        evictionNum: res.data.evictionNum || 0,
        vacancyNum: res.data.vacancyNum || 0,
      });

      setPropertyYear({
        period_start_min: res.data.period_start_min,
        period_end_max: res.data.period_end_max,
      });
    } catch (err) {
      console.error(err);
      message.error("Request error");
    } finally {
      setPropertyLoading(false);
    }
  };
const initColunmsFn = () => {
  setTableHead(initTableHead);
};
  // ================= 监听 =================
  useEffect(() => {
    if (visible) {
         initColunmsFn();
      getTableListFn();
    }
  }, [visible, ownerId, period]);

  const tableBoxRef = useRef(null);
const [tableScrollY, setTableScrollY] = useState(350);

useEffect(() => {
  const box = tableBoxRef.current;
  if (!box) return;

  const measure = () => {
    const headH = box.querySelector(".ant-table-thead")?.offsetHeight || 56;
    setTableScrollY(Math.max(150, box.clientHeight - headH));
  };

  measure();
  const ro = new ResizeObserver(measure);
  ro.observe(box);
  return () => ro.disconnect();
}, [visible, propertyLoading]);
  if (!visible) return null;

  return (
    <div className="property-bottom-panel property-bottom-panel-open">
      <Button
        type="default"
        shape="circle"
        icon={<DownOutlined />}
        className="property-collapse-btn"
        onClick={onClose}
      />

      <Card className="section-card property-card">
        <div className="section-card-header-property">
          <div>
            <div className="section-card-title">Property Detail</div>

            {propertyCounts.total > 0 && (
              <div className="property-modal-subtitle">
                Showing
                <span style={{ marginLeft: 8, color: "#0f9d58" }}>
                  {propertyCounts.active} Active Props
                  {propertyCounts.activeUnits > 0 &&
                    ` (${propertyCounts.activeUnits} Units)`}
                </span>
                <span style={{ marginLeft: 12, color: "#0958d9" }}>
                  {propertyCounts.inactive} Inactive
                  {propertyCounts.inactiveUnits > 0 &&
                    ` (${propertyCounts.inactiveUnits} Units)`}
                </span>
              </div>
            )}

            {ownerRecord && (
              <div className="property-modal-meta">
                <span className="property-modal-meta-owner">
                  {ownerRecord.owner_code}
                </span>
                {(propertyYear.period_start_min ||
                  propertyYear.period_end_max) && (
                  <span className="property-modal-meta-period">
                    {" "}
                    Data source scope: {propertyYear.period_start_min} -{" "}
                    {propertyYear.period_end_max}
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="property-card-wrapper">
            {/* Positive Cash Flow */}
            <div className="property-card-statistics">
              <div className="property-card-left">
                <div className="property-card-label">Positive Cash Flow</div>
                <div
                  className={getPropertyValueClassName(
                    propertyCounts.positiveCashFlow,
                  )}
                  title={String(propertyCounts.positiveCashFlow)}
                >
                  {propertyCounts.positiveCashFlow}
                </div>
              </div>
              <div className="property-card-right">
                <img
                  src={require("@/assets/images/icons/money_decline.png")}
                  alt="rise"
                />
              </div>
            </div>

            {/* Negative Cash Flow */}
            <div className="property-card-statistics">
              <div className="property-card-left">
                <div className="property-card-label">Negative Cash Flow</div>
                <div
                  className={getPropertyValueClassName(
                    propertyCounts.negativeCashFlow,
                  )}
                  title={String(propertyCounts.negativeCashFlow)}
                >
                  {propertyCounts.negativeCashFlow}
                </div>
              </div>
              <div className="property-card-right">
                <img
                  src={require("@/assets/images/icons/money_rise.png")}
                  alt="decline"
                />
              </div>
            </div>

            <div className="property-card-statistics">
              <div className="property-card-left">
                <div className="property-card-label">Cash Flow</div>
                <div
                  className={getPropertyValueClassName(propertyCounts.cashFlowAll)}
                  title={String(propertyCounts.cashFlowAll)}
                >
                  {propertyCounts.cashFlowAll}
                </div>
              </div>
              <div className="property-card-right">
                <img
                  src={require("@/assets/images/icons/money_3.png")}
                  alt="decline"
                />
              </div>
            </div>

            <div className="property-card-statistics">
              <div className="property-card-left">
                <div className="property-card-label">Vacancy/Eviction</div>
                <div
                  className={getPropertyValueClassName(
                    `${propertyCounts.vacancyNum}/${propertyCounts.evictionNum}`,
                  )}
                  title={`${propertyCounts.vacancyNum}/${propertyCounts.evictionNum}`}
                >
                  {propertyCounts.vacancyNum}/{propertyCounts.evictionNum}
                </div>
              </div>
              <div className="property-card-right">
                <img
                  src={require("@/assets/images/icons/tenant.png")}
                  alt="decline"
                />
              </div>
            </div>

            <div className="property-card-statistics">
              <div className="property-card-left">
                <div className="property-card-label">Vacancy</div>
                <div
                  className={getPropertyValueClassName(propertyCounts.vacancyAll)}
                  title={String(propertyCounts.vacancyAll)}
                >
                  {propertyCounts.vacancyAll}
                </div>
              </div>
              <div className="property-card-right">
                <img
                  src={require("@/assets/images/icons/home_1.png")}
                  alt="decline"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="section-card-table">
          <CustomTable
            tableLoading={propertyLoading}
            tableList={propertyData}
            columns={propertyColumns}
            pagination={false}
            handleTableChange={handleTableChange}
            tableScrollY="350px"
          />
        </div>
      </Card>
    </div>
  );
}
